import { RootState } from 'types/root';
import { PrepareAdyenResp, PrepareResp, TransactionsCcState, UseCcPayResp } from 'types/transactions-cc';

export const transactionsCcTree = (state: RootState): TransactionsCcState => state.transactionsCc || {};

export const transactionsCcIsLoading = (state: RootState): boolean => transactionsCcTree(state).isLoading || false;

export const transactionsCcPrepareResp = (state: RootState): PrepareResp => transactionsCcTree(state).prepareResp || {};

export const transactionsCcPrepareAdyenResp = (state: RootState): PrepareAdyenResp =>
  transactionsCcTree(state).prepareAdyenResp || {};

export const transactionCcCaptureContext = (): string => '';

export const transactionFingerprintingId = (state: RootState): string =>
  transactionsCcPrepareResp(state).fingerprintingId || '';

export const transactionsKeyId = (): string => '';

export const useCcPayResp = (state: RootState): UseCcPayResp => transactionsCcTree(state).useCcPayResp || {};
